import * as paymentTypes from './paymentTypes';
import * as transactionTypes from './transactionTypes';
import * as userTypes from './userTypes';
import * as processors from './processors';
import * as statuses from './statuses';
import * as subscriptions from './subscriptions';
import * as products from './products';
import * as invoices from './invoices';
import * as cardSecurity from './cardSecurity';
import * as processorsPaymentMethods from './processorsPaymentMethods';
import * as connectedAppsStatuses from './connectedAppsStatuses';
import * as quickbooks from './quickbooks';
import * as notifications from './notifications';
import giftCardTransactionTypes from './giftCardTransactionTypes';
import currencies from './currencies';
import locale from './locale';
import * as tickets from './tickets';
import fileTypes from './fileTypes';
import * as merchantTypes from './merchant-types';
import SIC_CODES from './sicCodes';
import RECEIPTS from './receipts';
import SUGGESTIONS from './suggestions';
import CARD_BRANDS from './cardBrands';

export * as RECEIPTS from './receipts';
export * as SUGGESTIONS from './suggestions';
export * from './accessControl';
export * from './paymentTypes';
export * from './transactionTypes';
export * from './userTypes';
export * from './processors';
export * from './statuses';
export * from './subscriptions';
export * from './products';
export * from './invoices';
export * from './linkedApps';
export * from './modes';
export * from './processorsPaymentMethods';
export * from './tickets';
export * from './vTerminal';
export { default as currencies } from './currencies';
export * as giftCardTransactionTypes from './giftCardTransactionTypes';
export { default as locale } from './locale';
export { default as fileTypes } from './fileTypes';
export { default as SIC_CODES } from './sicCodes';
export * from './merchant-types';
export * from './states';

export const waitRespDate = 21; // days
export const waitRespDateChargeback = 7; // days
export const responseDateText = 'Please respond no later than ';
export const CHARGEBACK_REPEATS = { 1: 'N', 3: 'Y' };
export const CORP_TYPES = ['Individual', 'C-corp', 'S-corp', 'LLC', 'Non-profit'];
export const deliveryTimes = ['0-7 Days', '8-30 Days', '31-90 Days', '91+ Days'];
export const paymentMethods = ['swiped', 'manually keyed', 'e-commerce'];
export const merchantTitles = [
  'CEO',
  'CFO',
  'COO',
  'CTO',
  'Owner',
  'Partner Managing Member',
  'President',
  'Vice President',
  'General Manager',
  'Controller'
];
export const FORMAT_NUMBERS = { PHONE: 'PHONE', EIN: 'EIN', SS: 'SS', AMOUNT: 'AMOUNT' };
export const SMS_TYPES = {
  COMMON: 'common',
  VERIFY: 'verify'
};
export const UNNAMED_ACCOUNT = 'unnamed account';

export const PHONECODE_US = '+1';

export const CLIENT_TYPE = 'portal';

export const CONNECTED_APP_QUICKBOOKS = 'QUICKBOOKS';
export const TRANSACTION_SOURCE_VTERMINAL = 'vTerminal';
export const TRANSACTION_SOURCE_API = 'API';
export const TRANSACTION_SOURCE_TERMINAL = 'Terminal';
export const TRANSACTION_SOURCE_RECURRING = 'Recurring';
export const TRANSACTION_SOURCE_INVOICING = 'Invoicing';
export const TRANSACTION_SOURCE_CHECKOUT = 'checkout';
export const TRANSACTION_SOURCE_PLATFORM = 'Platform';
export const TRANSACTION_MAX_AMOUNT = 999999999.99;

export const PAYMENT_TYPE_CREDIT = 'CREDIT_CARD';
export const PAYMENT_TYPE_ACH = 'ACH';
export const PAYMENT_TYPE_GIFT_CARD = 'GIFT_CARD';
export const PAYMENT_TYPE_PINDEBIT = 'PINDEBIT_CARD';
export const PAYMENT_TYPE_PLDEBIT = 'PLDEBIT_CARD';

export const ABBREVIATIONS = [PAYMENT_TYPE_ACH];

export const MERCHANT_CHECKOUT_TYPE_STANDARD = 'STANDARD';
export const MERCHANT_CHECKOUT_TYPE_FEE = 'CONVENIENCE_FEE';

export const MERCHANT_CHECKOUT_TYPES = [MERCHANT_CHECKOUT_TYPE_STANDARD, MERCHANT_CHECKOUT_TYPE_FEE];

export const MERCHANT_CHECKOUT_RATE_TYPE_PERCENT = 'percent';
export const MERCHANT_CHECKOUT_RATE_TYPE_STATIC = 'static';

export const MERCHANT_FEE_TYPE_DISABLED = 'disabled';
export const MERCHANT_FEE_TYPE_CREDIT_DEBIT = 'credit/debit';
export const MERCHANT_FEE_TYPE_SWIPED_KEYED = 'swiped/keyed';

export const MERCHANT_FEE_TYPES = {
  [MERCHANT_FEE_TYPE_DISABLED]: 'Disabled',
  [MERCHANT_FEE_TYPE_CREDIT_DEBIT]: 'Credit / Debit',
  [MERCHANT_FEE_TYPE_SWIPED_KEYED]: 'Swiped / Keyed'
};

export const ASC = 'ascend';
export const DESC = 'descend';

export const ENV_DEV = 'development';
export const ENV_STAGING = 'staging';
export const ENV_PRODUCTION = 'production';

export const FILTER_TODAY = 'Today';
export const FILTER_YESTERDAY = 'Yesterday';
export const FILTER_MONTH_TO_DATE = 'Month_to_Date';
export const FILTER_LAST_MONTH = 'Last_Month';
export const FILTER_YEAR_TO_DATE = 'Year_to_Date';

export const TXN_SOURCE_PLATFORM = 'Platform';

export const MAIN_API = 'main_api';
export const OFFICE_API = 'office_api';

export default {
  ...paymentTypes,
  ...transactionTypes,
  ...processors,
  ...statuses,
  ...subscriptions,
  ...products,
  ...invoices,
  ...cardSecurity,
  giftCardTransactionTypes,
  currencies,
  locale,
  ...connectedAppsStatuses,
  ...quickbooks,
  ...userTypes,
  waitRespDate,
  waitRespDateChargeback,
  responseDateText,
  ...notifications,
  ...processorsPaymentMethods,
  ...tickets,
  fileTypes,
  ...merchantTypes,
  SIC_CODES,
  CHARGEBACK_REPEATS,
  CORP_TYPES,
  deliveryTimes,
  paymentMethods,
  merchantTitles,
  FORMAT_NUMBERS,
  SMS_TYPES,
  PHONECODE_US,
  CONNECTED_APP_QUICKBOOKS,
  CLIENT_TYPE,
  TRANSACTION_SOURCE_VTERMINAL,
  TRANSACTION_SOURCE_API,
  TRANSACTION_SOURCE_TERMINAL,
  TRANSACTION_SOURCE_RECURRING,
  TRANSACTION_SOURCE_INVOICING,
  TRANSACTION_SOURCE_CHECKOUT,
  TRANSACTION_SOURCE_PLATFORM,
  RECEIPTS,
  ABBREVIATIONS,
  PAYMENT_TYPE_CREDIT,
  PAYMENT_TYPE_ACH,
  PAYMENT_TYPE_GIFT_CARD,
  PAYMENT_TYPE_PINDEBIT,
  PAYMENT_TYPE_PLDEBIT,
  MERCHANT_CHECKOUT_TYPE_STANDARD,
  MERCHANT_CHECKOUT_TYPE_FEE,
  MERCHANT_CHECKOUT_TYPES,
  MERCHANT_CHECKOUT_RATE_TYPE_PERCENT,
  MERCHANT_CHECKOUT_RATE_TYPE_STATIC,
  MERCHANT_FEE_TYPES,
  MERCHANT_FEE_TYPE_DISABLED,
  MERCHANT_FEE_TYPE_CREDIT_DEBIT,
  MERCHANT_FEE_TYPE_SWIPED_KEYED,
  UNNAMED_ACCOUNT,
  ENV_DEV,
  ENV_STAGING,
  ENV_PRODUCTION,
  SUGGESTIONS,
  CARD_BRANDS,
  TXN_SOURCE_PLATFORM,
  MAIN_API,
  OFFICE_API
};
